<template>
  <v-app>
    <transition name="fade" mode="out-in">
      <router-view/>
    </transition>
  </v-app>
</template>
<script>
import { getToken } from "./utils/auth";

export default {
  name: "App",
}
</script>

<style>
#App {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
}

.estoquesm {
  position: absolute;
  width: inherit;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}

.fade-enter,
.fade-leave-to

/* .fade-leave-active em versões anteriores a 2.1.8 */
 {
  opacity: 0;
}
</style>



// WEBPACK FOOTER //
// src/App.vue